// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1g5rM","inner":"Footer_inner__3HdAr","nextIcon":"Footer_nextIcon__2gqq7","innerLeft":"Footer_innerLeft__2dDFb"};